import axios from 'axios';
import {setPathNameAction, setTokenAction, setLabAction, setUserAction,updateTokenAction, logOutAction, updateUserProfileStarded, updateUserProfileSuccess, searchStarted, searchSuccessed, updateLabStartAction, updateLabSuccessAction, fetchUsersStartAction, fetchUsersSuccessAction, setMenuStatusAction, fetchQuickAccessStartAction, fetchQuickAccessSuccessAction, createNewUserStartAction, createNewUserSuccessAction} from './actions';
import { AppState } from '..';
import { BASE_URL } from '../../inc/constants';
import { UserInterface, LabInterface, BaseState, NewUserInterface } from './types';
import { statement } from '@babel/template';

export const setMenuStatus = (isOpen: boolean) => {
  return (dispatch: any) =>  {
      dispatch(setMenuStatusAction(isOpen));
  };
};
export const setPathName = (path: string) => {
  return (dispatch: any) =>  {
      dispatch(setPathNameAction(path));
  };
};
export const setToken = (token: string) => {
  return (dispatch: any) =>  {
      dispatch(setTokenAction(token));
  };
};
export const setLab = (lab: any) => {
  return (dispatch: any) =>  {
      dispatch(setLabAction(lab));
  };
};
export const setUser = (user: any) => {
  return (dispatch: any) =>  {
      dispatch(setUserAction(user));
  };
};
export const updateUserProfile = (data: UserInterface, id :number) => {
  return (dispatch: any,getState: any) =>  {
      dispatch(updateUserProfileStarded());
      let state:AppState = getState();
      const headers = {Authorization: `token ${state.base.token}`};
      if (!id) id = state.base.user.id;
      axios.put(`${BASE_URL}/users/${id}/`, data,{headers})
      .then(res => {
        dispatch(updateUserProfileSuccess(res.data));
      })
      .then(r=>{
        dispatch(fetchUsers());
      })
      .catch(err => {
        handleCache(dispatch,err);
      });

  };
};
export const updateLaboratory = (data: LabInterface) => {
  return (dispatch: any,getState: any) =>  {
      dispatch(updateLabStartAction());
      let state:AppState = getState();
      const headers = {Authorization: `token ${state.base.token}`};
      axios.put(`${BASE_URL}/labs/${state.base.lab.id}/`, data,{headers})
      .then(res => {
        dispatch(updateLabSuccessAction(res.data));
      })
      .catch(err => {
        handleCache(dispatch,err);
      });

  };
};
export const updateToken = () => {
  return (dispatch: any) =>  {
      dispatch(updateTokenAction());
  };
};
export const logOut = () => {
  return (dispatch: any) =>  {
      dispatch(logOutAction());
      localStorage.clear();
      window.location.replace("/login");
  };
};

//general
export function handleCache(dispatch: any,err: any) {
  // alert(err.response.status);
  if(err.response) {//TODO: Handle other errors
    if(err.response.status == 403 || err.response.status == 401) {
      dispatch(logOut());
    }
  }
}

export const search = (q :string) => {
  return (dispatch: any,getState: any) =>  {
      dispatch(searchStarted());
      let state:AppState = getState();
      const headers = {Authorization: `token ${state.base.token}`};
      axios.get(`${BASE_URL}/search/${q}/`,{headers})
      .then(res => {
        dispatch(searchSuccessed(res.data));
      })
      .catch(err => {
        handleCache(dispatch,err);
      });

  };
};

const shouldFetchUsers = (state:any) => {
  return state.base.users.length <= 0
}
export const fetchUsers = () => {
  return (dispatch: any,getState: any) =>  {
      if(!shouldFetchUsers(getState()))
        return Promise.resolve();
      dispatch(fetchUsersStartAction());
      let state:AppState = getState();
      const headers = {Authorization: `token ${state.base.token}`};
      axios.get(`${BASE_URL}/users/`,{headers})
      .then(res => {
        dispatch(fetchUsersSuccessAction(res.data));
      })
      .catch(err => {
        handleCache(dispatch,err);
      });

  };
};
//Quick Access in dashboard
export const fetchDashboardData = () => {
  return (dispatch: any,getState: any) =>  {
      dispatch(fetchQuickAccessStartAction());
      let state:AppState = getState();
      const headers = {Authorization: `token ${state.base.token}`};
      axios.get(`${BASE_URL}/dashboard/`,{headers})
      .then(res => {
        dispatch(fetchQuickAccessSuccessAction(res.data.quick_access));
      })
      .catch(err => {
        handleCache(dispatch,err);
      });
  };
};

export const createNewUser = (uesr: NewUserInterface,then?:Function) => {
  return (dispatch: any,getState: any) =>  {
      dispatch(createNewUserStartAction());
      let state:AppState = getState();
      const headers = {Authorization: `token ${state.base.token}`};
      axios.post(`${BASE_URL}/users/`,uesr,{headers})
      .then(res => {
        dispatch(createNewUserSuccessAction());
        if(then)then()
      })
      .catch(err => {
        handleCache(dispatch,err);
      });
  };
};